import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import global_en from "./locales/en/global.json";
import global_pr from "./locales/pr/global.json";

i18n.use(initReactI18next).init({
    interpolation: { escapeValue: false },
    lng: "pr",
    fallback: "pr",
    resources: {
        en: { translation: global_en },
        pr: { translation: global_pr }
    }
});

export default i18n;
